<nz-breadcrumb class="pb-15">
    <nz-breadcrumb-item>
        <ng-container *ngIf="isHome">
            <i nz-icon nzType="home"></i> Home
        </ng-container>
        <ng-container *ngIf="!isHome">
            <a routerLink="/home" routerLinkActive="router-link-active" ><i nz-icon nzType="home"></i></a>
        </ng-container>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item *ngFor="let item of breadcrumbs; let idx = index">
        <a *ngIf="idx < breadcrumbs.length - 1" routerLink="{{item.page}}" routerLinkActive="router-link-active" >
            <i *ngIf="item.icon" nz-icon nzType="{{item.icon}}"></i><span>{{item.title | translate}}</span>
        </a>
        <span *ngIf="idx === breadcrumbs.length - 1"><i *ngIf="item.icon" nz-icon nzType="{{item.icon}}"></i><span>{{item.title | translate}}</span></span>
    </nz-breadcrumb-item>
</nz-breadcrumb>